/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Guedder API
 * Contrato oficial da API v3 do Guedder (API-First).
 *
 * ## Modelo de resposta
 *
 * A v3 NÃO usa envelope. O status HTTP 2xx já comunica sucesso e o cliente
 * gerado é uma sealed-union por status-code. Sem `success`/`code`/`message` de
 * cerimônia. Respostas de objeto único retornam o tipo de domínio diretamente:
 * ```json
 * // 200 GET /api/v3/eventos/{eventoId}  → DadosBasicosEventoDto
 * { "id": "...", "nome": "..." }
 * ```
 *
 * ## Paginação
 *
 * TODA resposta de coleção usa um único shape canônico `Paged<T>`:
 * ```json
 * // 200 GET /api/v3/eventos  → Paged<DadosBasicosEventoDto>
 * { "content": [ { "id": "...", "nome": "..." } ], "page": { PageInfo } }
 * ```
 * `PageInfo` é offset-based, compatível com Spring Data `Page<T>`. Coleções
 * bounded (categorias, carrossel de destaque, devices, line-up) retornam uma
 * página única; params reais (`page`/`size`/`sort`) podem ser adicionados depois
 * sem quebrar o contrato (adição não-breaking).
 *
 * ## Erros
 *
 * Erro tem um único modelo: RFC 7807 (`ProblemDetail`), gerado nativamente pelo
 * Spring 6+. Validação de campo vem em `errors[]` dentro do próprio ProblemDetail.
 * ```json
 * { "type": "...", "title": "Not Found", "status": 404, "detail": "..." }
 * ```
 *
 * ## Convenções v3.1
 *
 * A v3.1 consolida as convenções de nomeação de recursos:
 * - **Sem sufixo `/publico`**: endpoints públicos não carregam mais o sufixo
 *   `/publico` no path; a ausência de `security` já comunica que são abertos.
 * - **Recursos plurais em kebab-case**: coleções usam nomes plurais
 *   (`/eventos`, `/ingressos`, `/compras`, `/cotacoes`) e paths compostos usam
 *   kebab-case (`/notification-tokens`, `/categorias-evento`,
 *   `/transferencias-pendentes`, `/wallet-config`).
 * - **Sub-recursos aninhados sob `/eventos`**: atrações, lotes, parâmetros de
 *   venda, visualizações e ingressos de check-in são modelados como
 *   sub-recursos de `/eventos/{eventoId}/...`.
 * - **Dois enums distintos para ingresso**: `StatusPagamentoIngresso` (estado
 *   de pagamento) e `CicloDeVidaIngresso` (eixo temporal: ativo/encerrado)
 *   deixam de ser misturados em um único enum. A custódia do ingresso
 *   (transferência em curso) é um terceiro eixo, servido pelo recurso
 *   `/transferencias-pendentes` — ver ADR-0016.
 *
 * ## Caixa dos enums
 *
 * Todo enum desta API é aceito em **qualquer caixa** na entrada — em query
 * params, path params e corpo JSON. `?cicloDeVida=ativo`, `Ativo` e `ATIVO`
 * são equivalentes.
 *
 * Isto é uma garantia do contrato, não um detalhe de implementação: existe
 * para que URLs compartilháveis e chamadas escritas à mão (curl, Postman)
 * não precisem carregar o valor em maiúsculo, que é desconfortável de ler e
 * digitar.
 *
 * A **saída** continua sempre no valor canônico em MAIÚSCULO. Clientes devem
 * comparar respostas contra o valor canônico, nunca assumir a caixa que
 * enviaram.
 *
 * ## Datas e fuso horário
 *
 * Datas têm **dois tipos distintos** neste contrato (ADR-0009), hoje
 * confundidos sob o mesmo `format: date-time`:
 *
 * - **Instante de auditoria** — `dataCriacao`, `dataCompra`, `dataCheckin`,
 *   `checkIn`, `realizadoEm`, `ProblemDetail.timestamp`. É um instante UTC
 *   (`...Z`); a zona não é semanticamente relevante e o valor deve ser
 *   renderizado no fuso do dispositivo.
 * - **Hora-de-parede do evento** — `dataInicio`, `dataFim`, `inicioVendas`,
 *   `terminoVendas`, `dataInicioSessao`/`dataFimSessao`,
 *   `inicioCheckin`/`terminoCheckin`, `dataEvento`, `dataFimEvento`. Também
 *   viaja como instante UTC no fio, mas representa uma hora local num lugar:
 *   deve ser renderizada **no fuso do evento**.
 *
 * Cada campo diz a qual dos dois pertence, na própria `description`.
 *
 * Todo recurso que carrega hora-de-parede expõe um campo `timezone` (IANA,
 * ex.: `America/Sao_Paulo`) — inclusive os que apenas desnormalizam a data de
 * um evento (ingresso, transferência, repasse), justamente para o cliente
 * nunca precisar buscar o evento só para saber em que fuso renderizar.
 *
 * **Renderizar hora-de-parede no fuso do dispositivo, ou com offset chumbado
 * (`-0300`), é incorreto**: quebra em horário de verão e em qualquer evento
 * fora do Brasil. Cada cliente usa sua ferramenta nativa
 * (`Temporal.ZonedDateTime` no web, `package:timezone` no Flutter) — o padrão
 * compartilhado é o contrato, não a biblioteca.
 *
 * Nas **requisições**, todo valor `format: date-time` (corpo ou query param)
 * deve carregar offset explícito ISO-8601 — `Z` ou `±hh:mm`. Não existe fuso
 * implícito de servidor: omitir o offset é erro do cliente. Já `format: date`
 * (ex.: `dataNascimento`) é data de calendário, sem hora e sem fuso — a regra
 * não se aplica.
 *
 * Duas exceções de compatibilidade Sympla em `GET /api/v3/eventos`, ambas
 * fora da convenção acima: os params `from`/`to` usam o formato Sympla
 * `YYYY-MM-DD[ HH:mm:ss]` interpretado em UTC e **não** aceitam offset; e o
 * param `timezone` daquela rota é filtro de compatibilidade — **não** é o
 * fuso do evento.
 *
 * ## Retrocompatibilidade
 *
 * Os paths `/api/v1/...` e `/api/v2/...` permanecem funcionais com seu próprio
 * envelope `RestObject`. A v3 diverge deliberadamente dessa simetria (ver ADR
 * de modelagem de resposta v3): é superfície nova, contract-first, gerada.
 * Os clients gerados apontam para `/api/v3/...`.
 *
 * OpenAPI spec version: 3.8.0
 */
import {
  HttpClient
} from '@angular/common/http';

import {
  inject
} from '@angular/core';

import {
  injectMutation,
  injectQuery
} from '@tanstack/angular-query-experimental';
import type {
  CreateMutationOptions,
  CreateMutationResult,
  CreateQueryOptions,
  CreateQueryResult,
  MutationFunction,
  QueryFunction
} from '@tanstack/angular-query-experimental';

import {
  fromEvent,
  lastValueFrom
} from 'rxjs';

import {
  takeUntil
} from 'rxjs/operators';

import type {
  BadRequestResponse,
  CheckoutContextDto,
  CheckoutSessionResponse,
  CotacaoResponse,
  CriarCheckoutSessionBody,
  CupomValidacaoDto,
  DadosCarrinhoPayload,
  NotFoundResponse,
  ParametrosVendaEvento,
  UnauthorizedResponse,
  WalletConfig
} from '../schemas';





export const criarCheckoutSession = (
    http: HttpClient,
    criarCheckoutSessionBody?: CriarCheckoutSessionBody, options?: { signal?: AbortSignal | null }
  ): Promise<CheckoutSessionResponse> => {

    const url = `/api/v3/checkout-session`;
    const request$ = http.post<CheckoutSessionResponse>(url, criarCheckoutSessionBody);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getCriarCheckoutSessionMutationOptions = <TError = UnauthorizedResponse,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof criarCheckoutSession>>, TError,{data?: CriarCheckoutSessionBody}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof criarCheckoutSession>>, TError,{data?: CriarCheckoutSessionBody}, TContext> => {

const mutationKey = ['criarCheckoutSession'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof criarCheckoutSession>>, {data?: CriarCheckoutSessionBody}> = (props) => {
          const {data} = props ?? {};

          return  criarCheckoutSession(http, data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CriarCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof criarCheckoutSession>>>
    export type CriarCheckoutSessionMutationBody = CriarCheckoutSessionBody | undefined
    export type CriarCheckoutSessionMutationError = UnauthorizedResponse

    /**
 * @summary Cria uma sessão de compra e retorna o session token JWT
 */
export const injectCriarCheckoutSession = <TError = UnauthorizedResponse,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof criarCheckoutSession>>, TError,{data?: CriarCheckoutSessionBody}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof criarCheckoutSession>>,
        TError,
        {data?: CriarCheckoutSessionBody},
        TContext
      > => {
      const http = inject(HttpClient);
      const criarCheckoutSessionMutationOptions = getCriarCheckoutSessionMutationOptions(http, options);

      return injectMutation(() => criarCheckoutSessionMutationOptions);
    }
    export const criarCotacao = (
    http: HttpClient,
    dadosCarrinhoPayload: DadosCarrinhoPayload, options?: { signal?: AbortSignal | null }
  ): Promise<CotacaoResponse> => {

    const url = `/api/v3/cotacoes`;
    const request$ = http.post<CotacaoResponse>(url, dadosCarrinhoPayload);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getCriarCotacaoMutationOptions = <TError = BadRequestResponse,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof criarCotacao>>, TError,{data: DadosCarrinhoPayload}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof criarCotacao>>, TError,{data: DadosCarrinhoPayload}, TContext> => {

const mutationKey = ['criarCotacao'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof criarCotacao>>, {data: DadosCarrinhoPayload}> = (props) => {
          const {data} = props ?? {};

          return  criarCotacao(http, data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CriarCotacaoMutationResult = NonNullable<Awaited<ReturnType<typeof criarCotacao>>>
    export type CriarCotacaoMutationBody = DadosCarrinhoPayload
    export type CriarCotacaoMutationError = BadRequestResponse

    /**
 * @summary Calcula o orçamento de uma seleção de lotes (público, sem auth)
 */
export const injectCriarCotacao = <TError = BadRequestResponse,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof criarCotacao>>, TError,{data: DadosCarrinhoPayload}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof criarCotacao>>,
        TError,
        {data: DadosCarrinhoPayload},
        TContext
      > => {
      const http = inject(HttpClient);
      const criarCotacaoMutationOptions = getCriarCotacaoMutationOptions(http, options);

      return injectMutation(() => criarCotacaoMutationOptions);
    }
    export const getParametrosVenda = (
    http: HttpClient,
    eventoId: string, options?: { signal?: AbortSignal | null }
  ): Promise<ParametrosVendaEvento> => {

    const url = `/api/v3/eventos/${eventoId}/parametros-venda`;
    const request$ = http.get<ParametrosVendaEvento>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getGetParametrosVendaQueryKey = (eventoId: string,) => {
    return [
    `/api/v3/eventos/${eventoId}/parametros-venda`
    ] as const;
    }


export const getGetParametrosVendaQueryOptions = <TData = Awaited<ReturnType<typeof getParametrosVenda>>, TError = NotFoundResponse>(http: HttpClient, eventoId: string, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getParametrosVenda>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParametrosVendaQueryKey(eventoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getParametrosVenda>>> = ({ signal }) => getParametrosVenda(http, eventoId, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof getParametrosVenda>>, TError, TData>
}

export type GetParametrosVendaQueryResult = NonNullable<Awaited<ReturnType<typeof getParametrosVenda>>>
export type GetParametrosVendaQueryError = NotFoundResponse


/**
 * @summary Retorna as formas de pagamento e regras de venda de um evento
 */

export function injectGetParametrosVenda<TData = Awaited<ReturnType<typeof getParametrosVenda>>, TError = NotFoundResponse>(
 eventoId: string | (() => string), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getParametrosVenda>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getParametrosVenda>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getGetParametrosVendaQueryOptions(http, _eventoId, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const getWalletConfig = (
    http: HttpClient,
    options?: { signal?: AbortSignal | null }
  ): Promise<WalletConfig> => {

    const url = `/api/v3/wallet-config`;
    const request$ = http.get<WalletConfig>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getGetWalletConfigQueryKey = () => {
    return [
    `/api/v3/wallet-config`
    ] as const;
    }


export const getGetWalletConfigQueryOptions = <TData = Awaited<ReturnType<typeof getWalletConfig>>, TError = unknown>(http: HttpClient,  options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getWalletConfig>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWalletConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWalletConfig>>> = ({ signal }) => getWalletConfig(http, { signal, ...fetchOptions });





   return  { queryKey, queryFn, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof getWalletConfig>>, TError, TData>
}

export type GetWalletConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getWalletConfig>>>
export type GetWalletConfigQueryError = unknown


/**
 * @summary Retorna a configuração de Google Pay / Apple Pay
 */

export function injectGetWalletConfig<TData = Awaited<ReturnType<typeof getWalletConfig>>, TError = unknown>(
  options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getWalletConfig>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getWalletConfig>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getGetWalletConfigQueryOptions(http, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const getCheckoutContext = (
    http: HttpClient,
    eventoId: string,
    dadosCarrinhoPayload: DadosCarrinhoPayload, options?: { signal?: AbortSignal | null }
  ): Promise<CheckoutContextDto> => {

    const url = `/api/v3/eventos/${eventoId}/checkout-context`;
    const request$ = http.post<CheckoutContextDto>(url, dadosCarrinhoPayload);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getGetCheckoutContextMutationOptions = <TError = BadRequestResponse | NotFoundResponse,
    TContext = unknown>(http: HttpClient, options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof getCheckoutContext>>, TError,{eventoId: string;data: DadosCarrinhoPayload}, TContext>, fetch?: RequestInit}
): CreateMutationOptions<Awaited<ReturnType<typeof getCheckoutContext>>, TError,{eventoId: string;data: DadosCarrinhoPayload}, TContext> => {

const mutationKey = ['getCheckoutContext'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCheckoutContext>>, {eventoId: string;data: DadosCarrinhoPayload}> = (props) => {
          const {eventoId,data} = props ?? {};

          return  getCheckoutContext(http, eventoId,data,fetchOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetCheckoutContextMutationResult = NonNullable<Awaited<ReturnType<typeof getCheckoutContext>>>
    export type GetCheckoutContextMutationBody = DadosCarrinhoPayload
    export type GetCheckoutContextMutationError = BadRequestResponse | NotFoundResponse

    /**
 * @summary Contexto de checkout agregado (parâmetros + cotação + wallet + sessão + idempotência) numa chamada
 */
export const injectGetCheckoutContext = <TError = BadRequestResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:CreateMutationOptions<Awaited<ReturnType<typeof getCheckoutContext>>, TError,{eventoId: string;data: DadosCarrinhoPayload}, TContext>, fetch?: RequestInit}
 ): CreateMutationResult<
        Awaited<ReturnType<typeof getCheckoutContext>>,
        TError,
        {eventoId: string;data: DadosCarrinhoPayload},
        TContext
      > => {
      const http = inject(HttpClient);
      const getCheckoutContextMutationOptions = getGetCheckoutContextMutationOptions(http, options);

      return injectMutation(() => getCheckoutContextMutationOptions);
    }
    export const validarCupom = (
    http: HttpClient,
    eventoId: string,
    nome: string, options?: { signal?: AbortSignal | null }
  ): Promise<CupomValidacaoDto> => {

    const url = `/api/v3/eventos/${eventoId}/cupons/${nome}`;
    const request$ = http.get<CupomValidacaoDto>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getValidarCupomQueryKey = (eventoId: string,
    nome: string,) => {
    return [
    `/api/v3/eventos/${eventoId}/cupons/${nome}`
    ] as const;
    }


export const getValidarCupomQueryOptions = <TData = Awaited<ReturnType<typeof validarCupom>>, TError = NotFoundResponse>(http: HttpClient, eventoId: string,
    nome: string, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof validarCupom>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidarCupomQueryKey(eventoId,nome);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof validarCupom>>> = ({ signal }) => validarCupom(http, eventoId,nome, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined && nome !== null && nome !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof validarCupom>>, TError, TData>
}

export type ValidarCupomQueryResult = NonNullable<Awaited<ReturnType<typeof validarCupom>>>
export type ValidarCupomQueryError = NotFoundResponse


/**
 * @summary Valida um cupom de desconto para um evento
 */

export function injectValidarCupom<TData = Awaited<ReturnType<typeof validarCupom>>, TError = NotFoundResponse>(
 eventoId: string | (() => string),
    nome: string | (() => string), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof validarCupom>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof validarCupom>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    const _nome = typeof nome === 'function' ? nome() : nome;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getValidarCupomQueryOptions(http, _eventoId, _nome, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






